import _u from './util';
import _v from './vars';
import _f from './func';
import _top from './templates/toparticle_t';
import _ from 'lodash';


let resolveTop = null;

_v.topArticleId = window.location.search.toLowerCase().match(/_([^_]+)?artid(\d+)/);
if (_v.topArticleId != null) {
	_v.topArticleId = _v.topArticleId[2];
}
_v.topContId = window.location.search.toLowerCase().match(/_([^_]+)?contid(\d+)/);
if (_v.topContId != null) {
	_v.topContId = _v.topContId[2];
}
_v.isFYE = window.location.search.toLowerCase().match(/wnl_recnlnew/);

function topArticleApiUrl() {
	if (_v.topArticleId != null) {
		return 'https://www.' + _u.getDomain() + 'medscape.com/rec-engine/api/v1/content?article_id=' + _v.topArticleId;
	} else if (_v.topContId != null) {
		return 'https://www.' + _u.getDomain() + 'medscape.com/rec-engine/api/v1/content?aspen_feed_nid=' + _v.topContId;
	}
}

function removeTopLoader() {
	let topArticleLoadingSection = _u.qS('#left-rail-loading-section .pers-article-item');
	_u.removeElem(topArticleLoadingSection);
	if (_u.qS('#left-rail-loading-section') != null && _u.qS('#left-rail-loading-section').firstElementChild == null) {
		_u.removeElem(_u.qS('#left-rail-loading-section'));
	}
}

function resolveTopArticle() {
	removeTopLoader();
	resolveTop();
	document.dispatchEvent(new CustomEvent('topArticleLoaded'));
}

function getTopArticle() {
	return new Promise(function(resolve, reject) {
		resolveTop = resolve;
		if (_v.topArticleId != null || _v.topContId != null) {
			_u.apiGet(topArticleApiUrl()).then(data => {
				if (data.errorMessage != undefined) {
					resolveTopArticle();
					return;
				}
				if (data) {
					
					// Turn all null value into empty string for output in LoDash template
					Object.keys(_.pickBy(data, _.isNull)).forEach(function(key) {
						data[key] = '';
					});

					// Ensure URI is environment-specific
					if (typeof data.uri == 'string') {
						data.uri = data.uri.replace(/((https?:)?\/\/)([^\.]+)(.+)?\.(medscape\.)([^\/]+)/, '$1$3.' + _u.getDomain() + '$5$6');
					}

					if(window.location.search.indexOf("FYE")>-1 || _v.isFYE != null){
						data.uri = data.uri + '?src=FYE';
					}

					// Add Akamai resizer
					if (typeof data.imageUrl == 'string' && data.imageUrl.trim() != '') {
						data.imageUrl = data.imageUrl + '?interpolation=lanczos-none&resize=516:*';
					}
					
					// Parse Date
					if (data.contentType != 'Blog') {
						data.publicationDate = _u.timeParse(data.publicationDate);
					} else {
						data.publicationDate = '';
					}

					// Select LoDash template and adjust data as needed
					let currTemplate = _top.topArticle;

					// If CME
					if (typeof data.uri == 'string' && data.uri.indexOf("medscape.org") != -1) {
						let credVal = _f.getCmeCreditTypeValue(data.cmeCreditType);
						credVal.credits != undefined ? data.credits = credVal.credits : data.credits = '';
						credVal.credits != undefined && Number(credVal.creditvalue) > 0 ?
							data.cmeTagName = 'Accredited Education' : data.cmeTagName = 'Education';
						currTemplate = _top.cmeTopArticle;
					}
					
					// Decision Point / BTG
					if (typeof data.contentType == 'string' && data.contentType.toLowerCase() === "decision point") {
						data.publicationName = 'Medscape Decision Point';
						data.superTitle = '';
						currTemplate = _top.dpTopArticle;
					} else if (typeof data.contentType == 'string' && data.contentType.toLowerCase() === "beyond the guidelines") {
						data.publicationName = 'Medscape Decision Point';
						data.superTitle = 'BEYOND THE GUIDELINES';
						currTemplate = _top.dpTopArticle;
					}
					
					// Slideshow / Comp Report
					if (data.uri.indexOf('/slideshow/') !== -1 && data.title.indexOf('Compensation Report') !== -1) {
						currTemplate = _top.compReportTopArticle;
					} else if (data.uri.indexOf('/slideshow/') !== -1 && data.title.indexOf('Compensation Report') === -1) {
						data.publicationName = 'Slideshows';
						currTemplate = _top.slideshowTopArticle;
					}

					// Third-party
					if (typeof data.sourceOrigin != 'undefined' && data.sourceOrigin === 'krzana') {
						// Image credit for third party article
						if (typeof data.imageCredit != 'undefined' && data.imageCredit != null && data.imageCredit.trim() != '') {
							data.imageCredit = "Credit: " + data.imageCredit;
						}
						currTemplate = _top.thirdPartyTopArticle;
					}

					// Append to top of Feed Container
					document.querySelector('.feed-container').insertBefore(_u.strToDom(currTemplate(data)), document.querySelector('.feed-container').firstChild);

					resolveTopArticle();

				} else {
					resolveTopArticle();
				}
			}).catch((error) => {
				resolveTopArticle();
			});
		} else {
			resolveTopArticle();
		}
	});
}

export default getTopArticle;